/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Toast_Error3Inputs */

const en_coinvestments_submitticketsize_toast_error3 = /** @type {(inputs: Coinvestments_Submitticketsize_Toast_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit ticket size. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to submit ticket size. Please try again." |
*
* @param {Coinvestments_Submitticketsize_Toast_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_toast_error3 = /** @type {((inputs?: Coinvestments_Submitticketsize_Toast_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Toast_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_toast_error3(inputs)
});
export { coinvestments_submitticketsize_toast_error3 as "coInvestments_submitTicketSize_toast_error" }